<template>
  <path d="M6.428 8.357h5.143v-1.929c0-1.416-1.155-2.571-2.571-2.571s-2.571 1.155-2.571 2.571v1.929zM14.786 9.321v5.786c0 0.532-0.432 0.964-0.964 0.964h-9.643c-0.532 0-0.964-0.432-0.964-0.964v-5.786c0-0.532 0.432-0.964 0.964-0.964h0.321v-1.929c0-2.471 2.029-4.5 4.5-4.5s4.5 2.029 4.5 4.5v1.929h0.321c0.532 0 0.964 0.432 0.964 0.964z"></path>
</template>
